import { defineComponent as _defineComponent } from 'vue'
import {
  TUITranslateService,
  TUIStore,
  StoreName,
} from "@tencentcloud/chat-uikit-engine";
import {
  searchMessageTypeList,
  globalSearchTypeList,
  conversationSearchTypeList,
  searchMessageTypeDefault,
} from "../search-type-list";
import { searchMessageTimeList, searchMessageTimeDefault } from "../search-time-list";
import { ref, computed } from "../../../adapter-vue";
import Icon from "../../common/Icon.vue";
import DatePicker from "../../common/DatePicker/index.vue";
import downArrowIcon from "../../../assets/icon/down-icon.svg";
import closeIcon from "../../../assets/icon/input-close.svg";
import closeDarkIcon from "../../../assets/icon/close-dark.svg";
import { isPC, isUniFrameWork } from "../../../utils/env";
import { SEARCH_TYPE } from "../type";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  popupPosition: {
    type: String, // 分为底部弹出和侧边弹出两种形式:"bottom"/"aside"
    default: "bottom",
  },
  searchType: {
    type: String,
    default: "global", // "global":全局搜索, "conversation":会话内搜索
    validator(value: string) {
      return ["global", "conversation"].includes(value);
    },
  },
},
  emits: ["searchConfigChange", "closeInConversationSearch"],
  setup(__props, { emit: emits }) {

const props = __props





const searchTypeList = computed(() =>
  props?.searchType === "conversation" ? conversationSearchTypeList : globalSearchTypeList
);
const currentSearchMessageType = ref(searchMessageTypeDefault[props?.searchType as SEARCH_TYPE]);
const currentSearchMessageTime = ref(searchMessageTimeDefault);

const isTimeTabsShow = computed(() => {
  return (
    currentSearchMessageType.value.key !== "contact" &&
    currentSearchMessageType.value.key !== "group"
  );
});
const datePickerRangeDisplayType = computed((): string =>
  isPC && props.searchType === "global" && !isUniFrameWork ? "two" : "one"
);
const isDatePickerShow = ref<boolean>(false);

TUIStore.watch(StoreName.CUSTOM, {
  currentSearchMessageType: (typeObject: { value: any; searchType: string }) => {
    if (typeObject?.searchType === props?.searchType) {
      currentSearchMessageType.value =
        typeObject?.value || searchMessageTypeDefault[props?.searchType as SEARCH_TYPE];
    }
  },
  currentSearchMessageTime: (timeObject: { value: any; searchType: string }) => {
    if (timeObject?.searchType === props?.searchType) {
      currentSearchMessageTime.value = timeObject?.value || searchMessageTimeDefault;
    }
  },
});

const selectSearchType = (item: any) => {
  TUIStore.update(StoreName.CUSTOM, "currentSearchMessageType", {
    value: item,
    searchType: props.searchType,
  });
};

const selectSearchTime = (item: any) => {
  // 去除选日期情况触发 selectAllTime
  if (isDatePickerShow.value && item.key === "all") {
    isDatePickerShow.value = false;
  } else {
    isDatePickerShow.value = false;
    TUIStore.update(StoreName.CUSTOM, "currentSearchMessageTime", {
      value: item,
      searchType: props.searchType,
    });
  }
};

const handleSelectAllTimeClicked = () => {
  if (currentSearchMessageTime.value?.key !== "all") {
    TUIStore.update(StoreName.CUSTOM, "currentSearchMessageTime", {
      value: searchMessageTimeDefault,
      searchType: props.searchType,
    });
  } else {
    isDatePickerShow.value = true;
  }
};

const pickTimePeriod = (time: any) => {
  if (currentSearchMessageTime.value?.key === "all") {
    const { startDate, endDate } = time;
    const timePosition = Number((endDate?.toDate()?.getTime() / 1000).toFixed(0));
    const timePeriod = timePosition - Number((startDate?.toDate()?.getTime() / 1000).toFixed(0));
    const newSearchMessageTime = {
      key: currentSearchMessageTime.value.key,
      label: currentSearchMessageTime.value.label,
      value: {
        timePosition,
        timePeriod,
      },
    };
    TUIStore.update(StoreName.CUSTOM, "currentSearchMessageTime", {
      value: newSearchMessageTime,
      searchType: props.searchType,
    });
  }
};

const clearTimePicker = () => {
  isDatePickerShow.value = false;
  if (currentSearchMessageTime.value?.key === "all") {
    TUIStore.update(StoreName.CUSTOM, "currentSearchMessageTime", {
      value: searchMessageTimeDefault,
      searchType: props.searchType,
    });
  }
};

const closeSearchContainer = () => {
  emits("closeInConversationSearch");
};

return { __sfc: true,props, emits, searchTypeList, currentSearchMessageType, currentSearchMessageTime, isTimeTabsShow, datePickerRangeDisplayType, isDatePickerShow, selectSearchType, selectSearchTime, handleSelectAllTimeClicked, pickTimePeriod, clearTimePicker, closeSearchContainer, TUITranslateService, searchMessageTimeList, Icon, DatePicker, downArrowIcon, closeIcon, closeDarkIcon, isPC }
}

})